import type { CommentSummaryContent, CommentSummaryDto, ReportDto } from '@genoma/shared';

import { get, patch, post, put } from './api.ts';

export const fetchReport = (participantId: string) =>
  get<ReportDto>(`/reports/${participantId}`);

/** The signed-in leader's own report. They have no id to ask with. */
export const fetchMyReport = () => get<ReportDto>('/reports/mine');

/** Ask the model for a synthesis of the open comments. Coach and admin only. */
export const generateSummary = (participantId: string, force = false) =>
  post<CommentSummaryDto>(`/reports/${participantId}/summary`, { force });

/**
 * Sign the report off, or take the signature back.
 *
 * Approving hands it to P&O and to the leader at once — that is what the word
 * means here, not a tidy-up.
 */
export const setReportApproval = (participantId: string, approved: boolean) =>
  put<{ status: string }>(`/reports/${participantId}/approval`, { approved });

/** The action plan a leader reads. Coach and admin only; the API enforces it. */
export const saveNarrative = (participantId: string, narrative: string) =>
  put<{ narrative: string | null; updatedAt: string }>(
    `/reports/${participantId}/narrative`,
    { narrative },
  );

/** The coach's edit, their approval, or both. */
export const reviseSummary = (
  participantId: string,
  changes: { content?: CommentSummaryContent; approve?: boolean },
) => patch<CommentSummaryDto>(`/reports/${participantId}/summary`, changes);
